// Import node components and export specific members
// We don't use export * to avoid ambiguous exports of 'documentation'
import ClusterNode, { ClusterConfigBox } from './cluster';
import SyncInjectorNode, { SyncInjectorConfigBox } from './sync-injector';
import JavaScriptSourceNode, { JavaScriptSourceConfigBox } from './javascript-source';
import MobileSDKNode, { MobileSDKConfigBox } from './mobile-sdk';
import ServerSourceNode, { ServerSourceConfigBox } from './server-source';
import LoadBalancerNode, { LoadBalancerConfigBox } from './load-balancer';
import EventNode, { EventConfigBox } from './event';
import PipelineNode, { PipelineConfigBox } from './pipeline';
import TransformationsNode, { TransformationsConfigBox } from './transformations';
import DestinationNode, { DestinationConfigBox } from './destination';
import FilterNode, { FilterConfigBox } from './filter';
import SchemaEnforcementNode, { SchemaEnforcementConfigBox } from './schema-enforcement';
import BotFilteringNode, { BotFilteringConfigBox } from './bot-filtering';
import DataReplayNode, { DataReplayConfigBox } from './data-replay';
import TextNode, { TextConfigBox } from './text-node';
import NotesNode, { NotesConfigBox } from './notes-node';
import GroupNode, { GroupConfigBox } from './group-node';
import CustomNode, { CustomConfigBox } from './custom-node'; // Added CustomNode import

// Re-export the components
export {
  ClusterNode, ClusterConfigBox,
  SyncInjectorNode, SyncInjectorConfigBox,
  JavaScriptSourceNode, JavaScriptSourceConfigBox,
  MobileSDKNode, MobileSDKConfigBox,
  ServerSourceNode, ServerSourceConfigBox,
  LoadBalancerNode, LoadBalancerConfigBox,
  EventNode, EventConfigBox,
  PipelineNode, PipelineConfigBox,
  TransformationsNode, TransformationsConfigBox,
  DestinationNode, DestinationConfigBox,
  FilterNode, FilterConfigBox,
  SchemaEnforcementNode, SchemaEnforcementConfigBox,
  BotFilteringNode, BotFilteringConfigBox,
  DataReplayNode, DataReplayConfigBox,
  TextNode, TextConfigBox,
  NotesNode, NotesConfigBox,
  GroupNode, GroupConfigBox,
  CustomNode, CustomConfigBox // Added CustomNode export
};


// This object maps node types to their React components for use with ReactFlow
export const nodeTypes = {
  cluster: ClusterNode,
  'sync-injector': SyncInjectorNode,
  'javascript-source': JavaScriptSourceNode,
  'mobile-sdk': MobileSDKNode,
  'server-source': ServerSourceNode,
  'load-balancer': LoadBalancerNode,
  event: EventNode,
  pipeline: PipelineNode,
  transformations: TransformationsNode,
  // Legacy node types - these are deprecated and should be replaced with transformations node
  mapping: TransformationsNode, // Deprecated: Use transformations instead
  filter: FilterNode,
  destination: DestinationNode,
  'schema-enforcement': SchemaEnforcementNode,
  'bot-filtering': BotFilteringNode,
  'data-replay': DataReplayNode,
  // Layout node types
  'text-node': TextNode,
  'notes-node': NotesNode,
  'group': GroupNode,
  'custom': CustomNode, // Added CustomNode type
  // Add more node types here as they are implemented
};


export const configBoxes = {
  cluster: ClusterConfigBox,
  'sync-injector': SyncInjectorConfigBox,
  'javascript-source': JavaScriptSourceConfigBox,
  'mobile-sdk': MobileSDKConfigBox,
  'server-source': ServerSourceConfigBox,
  'load-balancer': LoadBalancerConfigBox,
  event: EventConfigBox,
  pipeline: PipelineConfigBox,
  transformations: TransformationsConfigBox,
  // Legacy node types - these are deprecated and should be replaced with transformations node
  mapping: TransformationsConfigBox, // Deprecated: Use transformations instead
  filter: FilterConfigBox,
  destination: DestinationConfigBox,
  'schema-enforcement': SchemaEnforcementConfigBox,
  'bot-filtering': BotFilteringConfigBox,
  'data-replay': DataReplayConfigBox,
  // Layout node types
  'text-node': TextConfigBox,
  'notes-node': NotesConfigBox,
  'group': GroupConfigBox,
  'custom': CustomConfigBox, // Added CustomConfigBox mapping
  // Add more config boxes here as they are implemented
};

// Import documentation from each node type
import { documentation as clusterDocumentation } from './cluster';
import { documentation as syncInjectorDocumentation } from './sync-injector';
import { documentation as javaScriptSourceDocumentation } from './javascript-source';
import { documentation as mobileSDKDocumentation } from './mobile-sdk';
import { documentation as serverSourceDocumentation } from './server-source';
import { documentation as loadBalancerDocumentation } from './load-balancer';
import { documentation as eventDocumentation } from './event';
import { documentation as pipelineDocumentation } from './pipeline';
import { documentation as transformationsDocumentation } from './transformations';
import { documentation as destinationDocumentation } from './destination';
import { documentation as filterDocumentation } from './filter';
import { documentation as schemaEnforcementDocumentation } from './schema-enforcement';
import { documentation as botFilteringDocumentation } from './bot-filtering';
import { documentation as dataReplayDocumentation } from './data-replay';
import { documentation as textNodeDocumentation } from './text-node';
import { documentation as notesNodeDocumentation } from './notes-node';
import { documentation as groupDocumentation } from './group-node';
import { documentation as customDocumentation } from './custom-node'; // Added CustomNode documentation import
import { documentation as emptyCanvasDocumentation, previewDocumentation as emptyCanvasEmbeddedDocumentation } from './empty-canvas';

export const nodeDocumentation = {
  cluster: clusterDocumentation,
  'sync-injector': syncInjectorDocumentation,
  'javascript-source': javaScriptSourceDocumentation,
  'mobile-sdk': mobileSDKDocumentation,
  'server-source': serverSourceDocumentation,
  'load-balancer': loadBalancerDocumentation,
  event: eventDocumentation,
  pipeline: pipelineDocumentation,
  transformations: transformationsDocumentation,
  // Legacy node types - these are deprecated and should be replaced with transformations node
  mapping: transformationsDocumentation, // Deprecated: Use transformations instead
  filter: filterDocumentation,
  destination: destinationDocumentation,
  'schema-enforcement': schemaEnforcementDocumentation,
  'bot-filtering': botFilteringDocumentation,
  'data-replay': dataReplayDocumentation,
  // Layout node types
  'text-node': textNodeDocumentation,
  'notes-node': notesNodeDocumentation,
  'group': groupDocumentation,
  'custom': customDocumentation, // Added CustomNode documentation mapping
  // Special documentation for when no nodes are selected
  'empty-canvas': emptyCanvasDocumentation,
  'empty-canvas-embedded': emptyCanvasEmbeddedDocumentation,
  // Add more documentation here as they are implemented
};
